import React, { Component } from "react";
import { Spinner } from "reactstrap";
import swal from "sweetalert";
import CustomFullSpinner from "../../../components/WebsiteComponents/CustomFullSpinner";
import CustomModal from "../../../components/WebsiteComponents/CustomModal";
import { axiosGet, axiosPost } from "../../../utils/AxiosApi";
import { fileUrl, moduleName, URL } from "../../../utils/Constants";
import {
  displayConfirmDeleteAlert,
  DISPLAYMESSAGE,
} from "../../../utils/DisplayMessage";
import {
  checkRolePermissions,
  getTravelAgencyData,
} from "../../../utils/Helper";
import CreateBusAgency from "./CreateBusAgency";
import Pagination from "react-js-pagination";

class BusAgency extends Component {
  state = {
    travelAgencyData: {},
    busAgencies: [],
    dataSpinner: false,
    deletePermission: false,
    createModal: false,
    edit: false,
    editPermission: false,
    selectedData: {},
    current_page: 1,
    totalItemsCount: 0,
    paginated_value: 10,
  };

  componentDidMount() {
    this.getTravelAgencyDataForInsert();
    this.getBusAgencies();
    this.permissions();
  }

  getBusAgencies = (pageNumber, paginated_value) => {
    let page = pageNumber || this.state.current_page
    let paginatedValue = paginated_value || this.state.paginated_value
    let param = {
      page: page,
      paginated_value: paginatedValue,
    }
    this.setState({ dataSpinner: true }, function () {
      axiosPost(
        URL.busAgencies + "/" + "get-bus-agencies", param,
        (response) => {
          if (response.status === 200) {
            this.setState({
              busAgencies: response.data.data.items,
              totalItemsCount: response.data.data.totalData,
              current_page: page,
              paginated_value: paginatedValue,
              dataSpinner: false,
            });
          }
        },
        (err) => {
          this.setState({ dataSpinner: false });
        }
      );
    });
  };

  getTravelAgencyDataForInsert = () => {
    let travelAgencyData = getTravelAgencyData();
    this.setState({ travelAgencyData: travelAgencyData });
  };

  handleCreateModal = () => {
    this.setState({ createModal: !this.state.createModal, edit: false });
  };

  handleDeleteBtnClick = (e, id) => {
    let params = { id: id };
    displayConfirmDeleteAlert(params, this.handleDelete);
  };

  handleDelete = (params) => {
    this.setState({ loader: true }, () => {
      axiosGet(URL.deleteBusAgencies + "/" + params.id, (response) => {
        if (response.status === 200) {
          swal("Success", DISPLAYMESSAGE.deleteSuccess, "success");
          this.setState({
            loader: false,
          });
          this.getBusAgencies();
        }
      });
    });
  };

  handleEdit = (item) => {
    this.setState({ selectedData: item, edit: true, createModal: true });
  };

  permissions = () => {
    this.setState({
      editPermission: checkRolePermissions("update", moduleName.busAgency),
      deletePermission: checkRolePermissions("delete", moduleName.busAgency),
    });
  };

  handlePaginatedValueChange = (value) => {
    let valuePage = parseInt(value);
    this.setState({ paginated_value: valuePage }, () => {
      this.getBusAgencies(1, valuePage);
    });
  };

  render() {
    const { current_page, paginated_value, totalItemsCount } = this.state;
    return (
      <>
        <div className="dashboardHeader">
          <strong>BUS AGENCIES</strong>
        </div>
        <div className="container-fluid h-100">
          <div className="row mt-2">
            <div className="col">
              {checkRolePermissions("create", moduleName.busAgency) ? (
                <button
                  className="btn btn-success"
                  onClick={this.handleCreateModal}
                >
                  Add Bus Agency
                </button>
              ) : null}
            </div>
          </div>
          <div className="row mt-2 h-100">
            <div className="col d-flex align-items-center justify-content-between flex-column">
              <div className="table-responsive w-100">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>S.N</th>
                      <th>Logo</th>
                      <th>Name</th>
                      <th>Address</th>
                      <th>Contact Details</th>
                      <th>Email</th>
                      {this.state.editPermission ||
                        this.state.deletePermission ? (
                        <th>Options</th>
                      ) : null}
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.busAgencies.length > 0 ? (
                      this.state.busAgencies.map((item, idx) => {
                        return (
                          <tr key={idx}>
                            <td>{idx + 1}</td>
                            <td>
                              {item.media && item.media.length > 0 ? (
                                <img
                                  src={
                                    fileUrl +
                                    "/" +
                                    item.media[0].id +
                                    "/" +
                                    item.media[0].file_name
                                  }
                                  className="logoDisplay"
                                />
                              ) : null}
                            </td>
                            <td>{item.name}</td>
                            <td>{item.address}</td>
                            <td>{item.contact_details}</td>
                            <td>{item.email}</td>
                            {this.state.editPermission ||
                              this.state.deletePermission ? (
                              <td>
                                {this.state.editPermission ? (
                                  <button
                                    className="btn btn-primary"
                                    onClick={() => this.handleEdit(item)}
                                  >
                                    <i class="fa-solid fa-pen-to-square"></i>
                                  </button>
                                ) : null}
                                {this.state.deletePermission ? (
                                  <button
                                    className="btn btn-danger ms-3"
                                    onClick={(e) =>
                                      this.handleDeleteBtnClick(e, item.id)
                                    }
                                  >
                                    <i class="fa-solid fa-trash"></i>
                                  </button>
                                ) : null}
                              </td>
                            ) : null}
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td
                          colSpan={
                            this.state.editPermission ||
                              this.state.deletePermission
                              ? 7
                              : 6
                          }
                          className="text-center p-3"
                        >
                          {this.state.dataSpinner ? (
                            <>
                              <Spinner color="primary"></Spinner>
                              <br />
                              Loading Data...
                            </>
                          ) : (
                            "No Bus Agency found. Create one first"
                          )}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {!this.state.busAgencies ? (
                <></>
              ) : (
                <div className="m-4 d-flex justify-content-center">
                  <Pagination
                    activePage={current_page}
                    itemsCountPerPage={paginated_value}
                    totalItemsCount={totalItemsCount}
                    onChange={(pageNumber) =>
                      this.getTravelAgencies(pageNumber, paginated_value)
                    }
                    itemClass="page-item"
                    linkClass="page-link"
                    firstPageText="First"
                    lastPageText="Last"
                  />
                  <div className="paginatoion_paginated_value ml-3">
                    <select
                      className="form-control"
                      value={this.state.paginated_value}
                      onChange={(e) => this.handlePaginatedValueChange(e.target.value)}
                    >
                      <option value={10}>10</option>
                      <option value={20}>20</option>
                      <option value={30}>30</option>
                      <option value={40}>40</option>
                      <option value={50}>50</option>
                    </select>
                  </ div>
                </div>
              )}
            </div>
          </div>

          <CustomModal
            modal={this.state.createModal}
            modalBody={
              <CreateBusAgency
                getBusAgencies={this.getBusAgencies}
                handleCreateModal={this.handleCreateModal}
                selectedData={this.state.selectedData}
                edit={this.state.edit}
                travelAgencyId={
                  this.state.travelAgencyData
                    ? this.state.travelAgencyData.id
                    : null
                }
              />
            }
            modalHeader={this.state.edit ? "Edit Bus Agency" : "Add Bus Agency"}
            size="lg"
            toggleModal={this.handleCreateModal}
          ></CustomModal>
        </div>
      </>
    );
  }
}

export default BusAgency;
